<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";
import PermissionService from "@/helpers/permissionService";

export default {
  page: {
    title: "Monitoring Review Soal",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = [];

    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_kompetensi_level",
      },
      {
        width: "auto",
        label: "Judul Diklat",
        name: "-",
      },
      {
        width: "auto",
        label: "Profesi",
        name: "nama_profesi",
      },
      {
        width: "auto",
        label: "Dahan Profesi",
        name: "dahan_profesi",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "kode_kompetensi",
      },
      {
        width: "auto",
        label: "Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Level Proficiency",
        name: "nama_level",
      },
      {
        width: "auto",
        label: "Status Verifikasi",
        name: "status_verifikasi",
      },
      {
        width: "auto",
        label: "Status Review",
        name: "status_review_kompetensi",
      },
      {
        width: "auto",
        label: "Jumlah Soal PG",
        name: "total_soal_pg",
      },
      {
        width: "auto",
        label: "Jumlah Soal BS",
        name: "total_soal_bs",
      },
      {
        width: "auto",
        label: "Jumlah Soal Menjodohkan",
        name: "total_soal_menjodohkan",
      },
      {
        width: "auto",
        label: "Jumlah Soal Essai",
        name: "total_soal_text",
      },
      {
        width: "150px",
        label: "Aksi",
        name: "-",
      },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Monitoring Review Soal",
      items: [
        {
          text: "Verifikasi",
          href: "/",
        },
        {
          text: "Monitoring Review Soal",
          active: true,
        },
      ],
      isWrite: PermissionService.isWrite("Monitoring Review Soal"),
      isRead: PermissionService.isRead("Monitoring Review Soal"),
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_kompetensi_level",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_kompetensi_level",
        dir: "desc",
        filter: {
          status_kompetensi_review: "",
          id_mprofesi: "",
          kode_kompetensi: "",
          idverif_kompetensi: "",
          idlevel_kompetensi: "",
        },
      },
      optionProfesi: [],
      optionKompetensi: [],
      optionLevelKompetensi: [],
      optionStatusReview: [
        { value: "COMPLETED", label: "Completed" },
        { value: "REVISION", label: "Revision" },
        { value: "REPAIRED", label: "Repaired" },
      ],

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    await this.getDataTable();
    this.getProfesi();
    this.getKompetensi();
    this.getLevelKompetensi();
    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
    this.debouncedGetDataTable = _.debounce(this.getDataTable.bind(this), 500);
  },
  methods: {
    getDataTable(resetPage = true) {
      if (resetPage) {
        this.tableFilter.page = 1;
      }
      this.loadingTable = true;

      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/review-monitoring",
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data || [];
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },

    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensi(search, loading);
      }
    },

    async getKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/verif-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          },
        )
        .then((response) => {
          this.optionKompetensi = response.data.data.data;
          if (loading) loading(false);
        });
    },

    async searchProfesi(search, loading) {
      loading(true);
      await this.getProfesi(search, loading);
    },

    async getProfesi(search = "", loading) {
      await axios
        .get(process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all", {
          params: {
            search: search,
            limit: 100,
          },
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        })
        .then((response) => {
          this.optionProfesi = response.data.data;
          if (loading) loading(false);
        });
    },

    getLevelKompetensi() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/level-kompetensi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          },
        )
        .then((response) => {
          this.optionLevelKompetensi = response.data.data;
        });
    },

    formatJudulDiklat(row) {
      const diklat = row.judul_diklat ?? row.diklat;
      if (!diklat) return "-";
      if (Array.isArray(diklat)) {
        const names = diklat
          .map((item) =>
            typeof item === "string" ? item : item?.nama_diklat,
          )
          .filter(Boolean);
        return names.length ? names.join(", ") : "-";
      }
      return diklat || "-";
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3 mb-3">
                <label for="filterStatusReview">Status Kompetensi</label>
                <select
                  id="filterStatusReview"
                  class="form-control"
                  v-model="tableFilter.filter.status_kompetensi_review"
                  @change="getDataTable()"
                >
                  <option value="">Semua Status</option>
                  <option
                    v-for="status in optionStatusReview"
                    :key="status.value"
                    :value="status.value"
                  >
                    {{ status.label }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterProfesi">Profesi</label>
                <v-select
                  id="filterProfesi"
                  class="style-chooser"
                  :options="optionProfesi"
                  :reduce="(item) => item.id_mprofesi"
                  label="nama_profesi"
                  v-model="tableFilter.filter.id_mprofesi"
                  placeholder="Semua Profesi"
                  @search="filterProfesi"
                  @update:modelValue="getDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKodeKompetensi">Kode Kompetensi</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterKodeKompetensi"
                  placeholder="Kode Kompetensi"
                  v-model="tableFilter.filter.kode_kompetensi"
                  @input="debouncedGetDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKompetensi">Kompetensi</label>
                <v-select
                  id="filterKompetensi"
                  class="style-chooser"
                  :options="optionKompetensi"
                  :reduce="(item) => item.idverif_kompetensi"
                  label="nama_kompetensi"
                  v-model="tableFilter.filter.idverif_kompetensi"
                  placeholder="Semua Kompetensi"
                  @search="filterKompetensi"
                  @update:modelValue="getDataTable()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterLevel">Level Profisiensi</label>
                <select
                  id="filterLevel"
                  class="form-control"
                  v-model="tableFilter.filter.idlevel_kompetensi"
                  @change="getDataTable()"
                >
                  <option value="">Semua Level</option>
                  <option
                    v-for="level in optionLevelKompetensi"
                    :key="level.idlevel_kompetensi"
                    :value="level.idlevel_kompetensi"
                  >
                    {{ level.nama_level }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterSearch">Cari Data</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterSearch"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="debouncedGetDataTable()"
                />
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td class="text-center" colspan="99">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="99">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td>{{ key_data + pagination.from }}</td>
                  <td>{{ formatJudulDiklat(row_data) }}</td>
                  <td>{{ row_data.nama_profesi ?? "-" }}</td>
                  <td>{{ row_data.dahan_profesi ?? "-" }}</td>
                  <td>{{ row_data.kode_kompetensi ?? "-" }}</td>
                  <td>{{ row_data.nama_kompetensi ?? "-" }}</td>
                  <td>{{ row_data.nama_level }}</td>
                  <td>
                    <span
                      class="badge font-size-12"
                      :class="{
                        'bg-warning':
                          row_data.status_verifikasi === 'DRAFT' ||
                          row_data.status_verifikasi === 'KOREKSI',
                        'bg-danger': row_data.status_verifikasi === 'REVISI',
                        'bg-info': row_data.status_verifikasi === 'PENDING',
                        'bg-success': row_data.status_verifikasi === 'APPROVED',
                      }"
                    >
                      {{ row_data.status_verifikasi }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge font-size-12"
                      :class="{
                        'bg-warning':
                          !row_data.status_review_kompetensi ||
                          row_data.status_review_kompetensi === 'PENDING',
                        'bg-danger': row_data.status_review_kompetensi === 'REVISION',
                        'bg-info': row_data.status_review_kompetensi === 'REPAIRED',
                        'bg-success':
                          row_data.status_review_kompetensi === 'COMPLETED',
                      }"
                    >
                      {{ row_data.status_review_kompetensi || "PENDING" }}
                    </span>
                  </td>
                  <td class="text-center">{{ row_data.total_soal_pg }}</td>
                  <td class="text-center">{{ row_data.total_soal_bs }}</td>
                  <td class="text-center">
                    {{ row_data.total_soal_menjodohkan }}
                  </td>
                  <td class="text-center">{{ row_data.total_soal_text }}</td>
                  <td class="text-center">
                    <div class="btn-group">
                      <router-link
                        class="btn btn-primary btn-sm text-nowrap"
                        :to="`/review-monitoring/${row_data.idverif_kompetensi_level}/soal`"
                      >
                        <i class="fa fa-tasks me-1"></i> Monitoring
                      </router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
